import { PerformanceLongAnimationFrameTiming } from './types';
import { isPerformanceLongAnimationFrameTiming } from './helpers/isPerformanceLongAnimationFrameTiming';

/**
 * Сборщик топ N длинных фреймов по продолжительности
 */
export class LongAnimationFrameCollector {
    private performanceObserver: PerformanceObserver;
    private loafs: PerformanceLongAnimationFrameTiming[] = [];

    /**
     * @param bufferSize максимальное количество сохраненных записей
     */
    constructor(private readonly bufferSize: number) {
        this.performanceObserver = new PerformanceObserver(this.onLoaf);
    }

    private onLoaf = (entries: PerformanceObserverEntryList) => {
        this.loafs.push(...entries.getEntries().filter(isPerformanceLongAnimationFrameTiming));
        if (this.loafs.length > this.bufferSize) {
            this.loafs.sort((a, b) => a.duration - b.duration);
            this.loafs.splice(0, this.loafs.length - this.bufferSize);
        }
    };

    /**
     * Запустить сбор
     * @param requestBuffered запросить события LoAF, которые собирались до вызова этого метода
     */
    start(requestBuffered?: boolean) {
        this.performanceObserver.observe({ type: 'long-animation-frame', buffered: requestBuffered });
    }

    /** Остановить сборщик */
    stop() {
        this.performanceObserver.disconnect();
    }

    /** Очистить буфер */
    clear() {
        this.loafs.length = 0;
    }

    /**
     * Получить записи, которые произошли в указанном диапазоне времени
     * @param start точка начала
     * @param stop точка конца
     */
    getRelatedLoAFs(start: DOMHighResTimeStamp, stop: DOMHighResTimeStamp) {
        return this.loafs.filter(loaf => {
            // Если LoAF закончился до начала события
            if (loaf.startTime + loaf.duration < start) {
                return false;
            }

            // Оставляем только те LoAF, которые произошли до конца события
            return loaf.startTime < stop;
        });
    }
}
